import { AppUpdate } from '@/types/updates';

export const update_2026_01: AppUpdate = {
  id: 'rhythmic-multi-sim-2026-01',
  slug: 'introducing-rhythmic-multi-simulation',
  title: 'Beyond Unity: Rhythmic Multi-Simulation Mode',
  description: 'March was about complexity. We moved from single-world physics to a multi-simulation architecture, allowing for orchestral visual compositions.',
  date: 'March 10, 2026',
  timestamp: 1773331200,
  category: 'FEATURE',
  version: '0.8.0',
  readTime: '6 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'Why One Simulation Scaling is Not Enough'
    },
    {
      type: 'text',
      content: 'In early 2026, we realized that complex music (like orchestral or layered electronic tracks) needed more than one physics world. If a single boundary reacts to both the kick drum and the high-hats, it becomes chaotic. We needed a way to separate instruments into their own dedicated physics "islands."'
    },
    {
      type: 'heading',
      content: 'The Multi-Simulation Engine'
    },
    {
      type: 'text',
      content: 'This month, we launched the "Multi-Sim" logic. This allows a creator to spawn multiple simulation containers on the same screen. Each container can have its own independent gravity, friction, ball count, and—most importantly—its own audio trigger.'
    },
    {
      type: 'list',
      content: [
        'Concurrent Physics Worlds: Run up to 4 separate simulations side-by-side or layered.',
        'Instrument Mapping: Assign "Simulation A" to the Bass frequencies and "Simulation B" to the Melody.',
        'Geometric Overlays: New visual dividers to help organize the screen into a professional "Visualizer" layout.',
        'Space Spiral Mode: A new experimental mode focused on recursive, spiral-based gravity patterns.'
      ]
    },
    {
      type: 'heading',
      content: 'Space Spiral: Mathematical Beauty'
    },
    {
      type: 'text',
      content: 'Along with Multi-Sim, we introduced the Space Spiral setting for the boundary. Instead of a simple circle, the boundary can now pulse in logarithmic patterns, creating a mesmerizing "rabbit hole" effect that pulls balls toward an infinite center. It is one of the most hypnotic modes we have ever developed.'
    },
    {
      type: 'highlight',
      content: '"Visualizing a song isn\'t just about volume; it\'s about separation. By giving every instrument its own world, we allow the viewer to literally see the arrangement of the music."'
    },
    {
      type: 'heading',
      content: 'Layout Intelligence'
    },
    {
      type: 'text',
      content: 'With multiple simulations, screen real estate became precious. We added a new "Layout Sorting" panel that allows you to drag and resize different simulation islands, creating custom bento-grid layouts for your final exports.'
    }
  ]
};
